export const pieChartOptions = {
    chart: {
        type: 'pie',
        width: 200,
        height: 200,
        backgroundColor: 'transparent',
    },
    title: {
        text: undefined,
    },
    tooltip: {
        headerFormat: undefined,
        pointFormat:
            '{point.name}: <b>{point.percentage:.1f}%</b> ({point.y})',
    },
    credits: {
        enabled: false,
    },
    legend: {
        enabled: false,
    },
    plotOptions: {
        pie: {
            dataLabels: {
                enabled: false,
            },
            showInLegend: true,
            point: {},
        },
        series: {
            point: {
                events: {
                    legendItemClick: function () {
                        return false; // returning false will cancel the default action
                    },
                },
            },
        },
    },
    series: [
        {
            data: [],
            dataLabels: {
                enabled: false,
            },
        },
    ],
};